import en from './seo/en';
import me from './seo/me';
import sq from './seo/sq';
import de from './seo/de';
import pl from './seo/pl';
import ru from './seo/ru';
import hu from './seo/hu';
import ro from './seo/ro';

// Per-language, per-page landing copy (H1, intro, H2 sections) — the same object feeds the on-page <SeoLanding/> and the build-time pre-render.
export const seoLanding = { en, me, sq, de, pl, ru, hu, ro };

// Language-neutral distance facts; place names come from seoTranslations.explore.attractions.
export const DISTANCES = [
  ['velikaPlaza', 1.8, 3], ['restaurants', 2, 4], ['oldTown', 2.5, 5], ['malaPlaza', 3.2, 7],
  ['ladiesBeach', 4, 8], ['saskoLake', 8, 12], ['adaBojana', 12, 15], ['valdanos', 15, 20],
];

export const seoFor = (lang, slug) => {
  const L = seoLanding[lang] || seoLanding.en;
  return { labels: L.labels, page: L[slug || 'home'] || seoLanding.en[slug || 'home'] };
};
